import styled, { css } from 'styled-components';
import theme from '../../assets/styles/theme';
import {
  MEDIUM_COMPONENT_SIZE,
  SMALL_COMPONENT_SIZE,
} from '../../utils/Constants';

const DragAndDropWrapper = styled.div``;

const DragAndDrop = styled.div`
  border-radius: ${theme.borderRadius['border-radius-3']};
  border: dashed 1px ${theme.colors.neutral.border.weak};
  background-color: ${theme.colors.neutral.bg.weak};
  display: flex;
  align-items: center;

  ${({ status }) => {
    if (status === 'error') {
      return css`
        border: dashed 1px ${theme.colors.danger.border.regular};
      `;
    }
  }}

  ${({ size }) => getSize(size)};

  ${({ disabled }) => disabled && getDisabled()}
  ${({ visible }) => {
    if (!visible) {
      return css`
        display: none;
      `;
    }
  }}
`;

const DropBaseIcon = styled.div`
  padding: ${theme.spacing['spacing-6']};
  margin: ${theme.spacing['spacing-2']};
  ${({ size }) =>
    size === SMALL_COMPONENT_SIZE &&
    css`
      padding: ${theme.spacing['spacing-5']};
      margin: ${theme.spacing['spacing-0']};
    `}
`;

const SuccessIcon = styled.div`
  padding: ${theme.spacing['spacing-6']} ${theme.spacing['spacing-3']}
    ${theme.spacing['spacing-6']} ${theme.spacing['spacing-6']};
  margin: ${theme.spacing['spacing-2']};

  ${({ size }) =>
    size === SMALL_COMPONENT_SIZE &&
    css`
      padding: ${theme.spacing['spacing-7']} ${theme.spacing['spacing-0']}
        ${theme.spacing['spacing-5']} ${theme.spacing['spacing-0']};
      margin: ${theme.spacing['spacing-0']};
    `}
`;

const MainTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing['spacing-5']} ${theme.spacing['spacing-0']}
    ${theme.spacing['spacing-5']} ${theme.spacing['spacing-0']};
  gap: ${theme.spacing['spacing-3']};
  min-width: 400px;
  ${({ size }) =>
    size === SMALL_COMPONENT_SIZE &&
    css`
      min-width: auto;
      max-width: 265px;
      padding: ${theme.spacing['spacing-0']};
      align-items: center;
    `}
`;

const FileInputLabel = styled.label`
  ${theme.textStyles['text-preset-9']()}
  color: ${theme.colors.info.text.regular};
  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${theme.colors.neutral.text.regular};
      cursor: not-allowed;
    `}
`;
const FileInput = styled.input`
  display: none;
`;

const ActionWrapper = styled.div`
  padding: ${theme.spacing['spacing-7']} ${theme.spacing['spacing-6']}
    ${theme.spacing['spacing-7']} ${theme.spacing['spacing-0']};
  width: 100%;
  text-align: right;

  ${({ size }) =>
    size === SMALL_COMPONENT_SIZE &&
    css`
      padding: ${theme.spacing['spacing-4']} ${theme.spacing['spacing-0']}
        ${theme.spacing['spacing-5']} ${theme.spacing['spacing-0']};
      text-align: center;
    `}
  ${({ size, deleteAction }) =>
    deleteAction &&
    size === SMALL_COMPONENT_SIZE &&
    css`
      padding-bottom: ${theme.spacing['spacing-6']};
      margin-bottom: ${theme.spacing['spacing-4']};
    `}
`;

const HelpText = styled.div`
  padding: ${theme.spacing['spacing-2']} ${theme.spacing['spacing-2']}
    ${theme.spacing['spacing-2']} ${theme.spacing['spacing-5']};
  display: flex;
  align-items: flex-start;
  ${({ status }) =>
    status === 'error' &&
    css`
      > * {
        &:first-child {
          margin-right: ${theme.spacing['spacing-2']};
        }
      }
    `}
  ${({ visible }) => {
    if (!visible) {
      return css`
        display: none;
      `;
    }
  }}
`;

const getSize = (size) => {
  switch (size) {
    case SMALL_COMPONENT_SIZE:
      return css`
        max-width: 312px;
        flex-direction: column;
      `;
    case MEDIUM_COMPONENT_SIZE:
      return css`
        min-width: 671px;
      `;
  }
};

const getDisabled = () => css`
  background: ${theme.colors.neutral.bg.regular};
`;

export {
  DragAndDropWrapper,
  DragAndDrop,
  DropBaseIcon,
  SuccessIcon,
  MainTextWrapper,
  FileInputLabel,
  FileInput,
  ActionWrapper,
  HelpText,
};
